module.exports = __webpack_public_path__ + "static/scale-model-of-rudee-inlet-stand-up-paddle-in-virginia-beach-virginia-f76946b5e7dfb3b8e54b3de239ccab2d.png";